import BaseService from '../../BaseService.js';

export default class WirtschaftszweigService extends BaseService {

    constructor() {
        super('wirtschaftszweige');
    }

}